// ======================================================================
// File Name       : EmailSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { VALIDATE_TYPE } from '../../constants';
import { MAIL_SEND_STATUS_TYPE } from '../../constants/EmailConstants';
import RenderField from '../../utils/ReduxFormUtils';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import CustomButton from '../button/CustomButton';
import ReduxFormPaging from '../ReduxFormPaging';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';

class EmailSearch extends React.Component {
  render() {
    const {
      showSelectGroupDlg,
      groupList,
      selectedGroup,
      removeSelectedGroup,
      onSearchBtnClick,
      onExportBtnClick,
      recordNum,
      getStartEndData,
    } = this.props;
    const groupNameString = (selectedGroup && selectedGroup.groupSecernId) ? convertNodeGroupToNodeString(selectedGroup.groupSecernId, groupList) : '';
    return (
      <div>
        <p className="margin-top-10">検索する項目を指定してください</p>
        <Form onSubmit={(e) => { e.preventDefault(); onSearchBtnClick(); }} className='form-horizontal'>
          <Col sm={12} className="margin-top-10">
            <Form.Group className="form-info" controlId="formHorizontalMailSubject">
              <Col as={Form.Label} sm={3}>件名</Col>
              <Col sm={7}>
                <RenderField
                  type="text"
                  name="emailTitle"
                  label="件名"
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info" controlId="formHorizontalUserName">
              <Col as={Form.Label} sm={3}>ユーザー名</Col>
              <Col sm={7}>
                <RenderField
                  type="text"
                  name="userName"
                  label="ユーザー名"
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info" controlId="formHorizontalGroup">
              <Col as={Form.Label} sm={3}>ユーザーグループ名</Col>
              <Col sm={2}>
                <Button
                  variant="primary"
                  className="btn-96"
                  onClick={showSelectGroupDlg}
                >
                  グループ選択
                </Button>
              </Col>
            </Form.Group>
            {/* usergroup show here */}
            {groupNameString &&
              <Form.Group className="form-info" controlId="formHorizontalGroup">
                <Col sm={3} />
                <Col sm={7} as={Form.Label} className="ps-0">
                  {groupNameString}
                </Col>
                <Col sm={2}>
                  <Button variant="primary" className="btn-96 margin-left-15" onClick={removeSelectedGroup.bind(this)}>削除</Button>
                </Col>
              </Form.Group>
            }
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                送信日
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="sendDateFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>～</Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="sendDateTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={12}>
                <RenderField
                  name="dateTimeMinMax"
                  type="dateTimeMinMax"
                  validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                  keyDateFrom={'sendDateFrom'}
                  keyDateTo={'sendDateTo'}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                送信結果
              </Col>
              <Col sm={7} className="padding-top-10">
                <RenderField
                  inline
                  className="padding-top-clear margin-right-10"
                  type="radio"
                  name="emailSendStatus"
                  value=""
                  label="選択なし"
                  normalizeRadio
                />
                <RenderField
                  inline
                  className="padding-top-clear margin-right-10"
                  type="radio"
                  name="emailSendStatus"
                  value={MAIL_SEND_STATUS_TYPE.SUCCESS}
                  label="送信済み"
                  normalizeRadio
                />
                <RenderField
                  inline
                  className="padding-top-clear"
                  type="radio"
                  name="emailSendStatus"
                  value={MAIL_SEND_STATUS_TYPE.FAILED}
                  label="送信失敗"
                  normalizeRadio
                />
              </Col>
            </Form.Group>
            <Form.Group className="margin-top-20 text-center">
              <Col sm={12} className="padding-left-right-clear">
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  type="submit"
                  text="検索"
                  iconClass="bi bi-search"
                />
              </Col>
            </Form.Group>
          </Col>
          <Form.Group>
              <Col className="padding-left-right-clear">
                <Col sm={9} className="inline-flex">
                  <CustomLink
                    className="btn-register margin-right-10 margin-bottom-10"
                    to={Path.EMAIL_REGISTER}
                    text="メール送信"
                    icon={ICON.REGIST}
                  />
                </Col>
                <Col sm={3}>
                  <CustomButton
                    btnStyle="btn-export-csv float-end"
                    handleClick={onExportBtnClick}
                    iconClass="bi bi-download"
                    text="一括出力"
                  />
                </Col>
              </Col>
            </Form.Group>
        </Form>
      </div>
    );
  }
}

export default EmailSearch;
